<template>
  <div class="card card-body rounded-top">
    <component-table
      entityType="medical_examination"
      addButtonEntityType="team"
      :addButtonEntityId="teamId"
      :actions="actions"
      :columns="columns"
      :data="list"
      :total="count"
      :hideSearchInput="true"
      @add="showAddModal()"
      @edit="showEditModal($event.id)"
      @delete="showDeleteDialog($event.id)"
    />

    <medical-examination-modal :show="showModal" :id="idToEdit" @save="add" @close="hideModal" @update="update" />
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

import ComponentTable from '@/components/table/Table';
import MedicalExaminationModal from '@/components/modals/MedicalExaminationModal';
import { listMixin } from '@/mixins/list';
import { EDIT_ACTION, DELETE_ACTION } from '@/utils/constants';

// @vuese
// Lista badań lekarskich zawodnika
// @group Team
export default {
  mixins: [
    listMixin('team/player/medicalExamination', {
      listError: 'messages.medicalExamination.listError',
      getError: 'messages.medicalExamination.getError',
      added: 'messages.medicalExamination.added',
      addError: 'messages.medicalExamination.addError',
      updated: 'messages.medicalExamination.updated',
      updateError: 'messages.medicalExamination.updateError',
      deleteConfirm: 'messages.medicalExamination.deleteConfirm',
      deleted: 'messages.medicalExamination.deleted',
      deleteError: 'messages.medicalExamination.deleteError'
    })
  ],
  components: { ComponentTable, MedicalExaminationModal },

  data() {
    return {
      columns: [
        { name: 'name', displayName: 'columns.name' },
        { name: 'dateEnd', displayName: 'columns.expirationDate', sortable: 'true', sortName: 'end' }
      ],
      actions: [
        { ...EDIT_ACTION, entityType: 'medicalExamination' },
        { ...DELETE_ACTION, entityType: 'medicalExamination' }
      ]
    };
  },
  computed: {
    teamId() {
      return this.$route.params.teamId;
    },
    ...mapState({
      list: state =>
        state.team.player.medicalExamination.list.map(medicalExamination => ({
          ...medicalExamination,
          dateEnd: moment(medicalExamination.end).format('DD-MM-Y')
        })),
      count: state => state.team.player.medicalExamination.count
    })
  }
};
</script>
